export const PHONE_REGEX = /^\\+7\\(9[0-9]{2}\\)-[0-9]{3}-[0-9]{2}-[0-9]{2}$/;
export const PHONE_REGEX_STR = '\\+7\\(9[0-9]{2}\\)-[0-9]{3}-[0-9]{2}-[0-9]{2}';
export const PHONE_MASK = '+7(###) ###-##-##';

export const FILE_SIZE_LABELS = ['Б', 'КБ', 'МБ', 'ГБ', 'ТБ'];

export const CONTACTS = {
	tg: {
		value: 'https://t.me/APP73BOT',
		link: 'https://t.me/APP73BOT',
		label: 'https://t.me/APP73BOT'
	},
	phone1: {
		value: '88002501311',
		link: 'tel:88002501311',
		label: '8 800 250-13-11'
	},
	mail: {
		value: 'info@app73.pro',
		link: 'mailto:info@app73.pro',
		label: 'info@app73.pro'
	}
};

export const MENUS = [
	{ title: 'Калькулятор', path: '/#calculator', desktop: false },
	{ title: 'О компании', path: '/#about', desktop: true },
	{ title: 'Этапы работы', path: '/#stages', desktop: true },
	{ title: 'Преимущества', path: '/#map', desktop: true },
	{ title: 'Контакты', path: '/#contacts', desktop: true }
];

export const SLIDE_SPEED = 3000; // 3 sec
export const SLIDES_TEXT = [
	'>1000 грузов\n доставлено',
	'>13 лет опыта',
	'120 тонн груза\n в месяц'
];

export const TEXT = {
	calc_link: 'Рассчитать\nстоимость'
};

export const CATEGORIES = [
	{
		name: 'raw',
		description: 'Для сырьевых (не химия)'
	},
	{
		name: 'ready',
		description: 'Для готовой продукции'
	},
	{
		name: 'equipment',
		description: 'Для оборудования/химии'
	}
];

export const CURRENCY = [
	{ name: 'cny', symbol: '¥' },
	{ name: 'eur', symbol: '€' },
	{ name: 'usd', symbol: '$' },
	{ name: 'rub', symbol: '₽' }
];

export const SEO = {
	title: 'Ж/Д доставка и консолидация грузов из Китая в Россию',
	description:
		'Железнодорожная перевозка сборных грузов - один из самых надёжных и выгодных способов доставки. Оказываем сервис "под ключ": выкуп и забор груза у поставщика, хранение на складе, страхование груза, полное таможенное сопровождение. Мы гарантируем индивидуальный подход к каждому. Доставляем по всей России от двери до двери, так же возможен самовывоз.',
	asd: ''
};

export const API_RESPONSE = {
	success:
		'Ваша заявка принята в обработку. Наш менеджер свяжется с вами в ближайшее время.',
	error: 'В данный момент невозможно отправить заявку, мы уже решаем эту проблему, отправьте заявку позже.'
};

export const STORAGE_KEY = {
	cookie: 'cookie',
	calculator: 'calculator'
};
